import { AnnexFinishResult, CreateAnnexIVDraftResponse } from '../types/Documentation.types';
import { AIGenerateJobResponse } from '../types/AIJob.types';
import API from './ApiBase';
import PythonAIAPI from './PythonAIApiBase';

export const createAnnexIVDraft = async (aiSystemId: string) => {
  const response = await API.post<CreateAnnexIVDraftResponse>(
    `/annex-iv/ai-systems/${aiSystemId}`
  );
  return response.data;
};

export const getAnnexIVByAiSystem = async (aiSystemId: string) => {
  const response = await API.get<CreateAnnexIVDraftResponse>(
    `/annex-iv/ai-systems/${aiSystemId}`
  );
  return response.data;
};

export interface AnnexFillResult {
  annexId: string;
  updatedFields: string[];
  aiSystemId: string;
  contentJson?: {
    documentControl?: Record<string, any>;
    systemOverview?: Record<string, any>;
    designAndDevelopment?: Record<string, any>;
    lifecycleRiskPostMarketAssurance?: Record<string, any>;
    footerNote?: Record<string, any>;
  };
}

export interface AnnexFillResponse {
  success: boolean;
  data: AnnexFillResult;
}

export const suggestAnnexContent = async (annexId: string): Promise<AnnexFillResponse> => {
  const response = await PythonAIAPI.patch<AnnexFillResponse>(
    `/annex/${annexId}`
  );
  return response.data;
};

export const generateAnnexIVContent = async (
  annexId: string
): Promise<AIGenerateJobResponse> => {
  const response = await API.post<AIGenerateJobResponse>(
    `/annex-iv/${annexId}/generate`
  );
  return response.data;
};

export interface UpdateAnnexIVPayload {
  systemOverview: {
    intendedPurpose: string | null;
    deploymentScope: string | null;
    formsInWhichTheSystemIsPlaced: string | null;
    hardware: string | null;
    componentOfAProduct: string | null;
    userInterfaceOverview: string | null;
    instructionsForUse: string | null;
  };
  designAndDevelopment: {
    developmentMethodsAndLifecycle: string | null;
    designSpecifications: string | null;
    systemArchitectureAndCompute: string | null;
    dataRequirementsAndDatasets: string | null;
    humanOversightMeasures: string | null;
    predeterminedChangesEnvelope: string | null;
    validationAndTesting: string | null;
    cybersecurityMeasures: string | null;
  };
  lifecycleRiskPostMarketAssurance: {
    performanceMetrics: string | null;
    riskManagementSystem: string | null;
    lifecycleChanges: string | null;
    standardsAndSpecifications: string | null;
    euDeclarationOfConformity: string | null;
    postMarketPerformanceAndMonitoringPlan: string | null;
  };
}

export const updateAnnexIV = async (
  annexId: string,
  payload: UpdateAnnexIVPayload
) => {
  const response = await API.put<CreateAnnexIVDraftResponse>(
    `/annex-iv/${annexId}`,
    payload
  );
  return response.data;
};

export const completeAnnexIV = async (
  annexId: string,
  payload: UpdateAnnexIVPayload
) => {
  const response = await API.put<AnnexFinishResult>(
    `/annex-iv/${annexId}/complete`,
    payload
  );
  return response.data;
};
